import { Box, Flex, Icon, Link, Text } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { MdOutlineDirections, MdOutlineMailOutline } from "react-icons/md"
import { RiPhoneLine } from "react-icons/ri"
import { RemoteStoreApi } from "./RemoteStoreTypes"

interface Props {
  store: RemoteStoreApi
}

const StoreAddress: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation()

  const { name, phone, emailAddress } = store
  const firstPartOfName = name.split(" ")[0]

  const address1 = store.address1 || ""
  const address2 = store.address2 || ""
  const city = store.city || ""
  const region = store.region || ""
  const postCode = store.postCode || ""

  const addressPart1 = `${address1} ${address2}`
  const addressPart2 = `${city}, ${region} ${postCode}`

  const hasPhoneNumber = Boolean(phone)
  const hasEmailAddress = Boolean(emailAddress)

  return (
    <Box>
      <Box>
        <Text as="h1">
          {t(`templates.layout.stores.Store.address.title`, {
            name: firstPartOfName,
          })}
        </Text>
      </Box>
      <Box mt={2}>
        <Text id="store-address" fontSize="2xl" fontWeight="bold">
          {addressPart1}
        </Text>
        <Text id="store-city" fontSize="2xl" fontWeight="bold" lineHeight={1.2}>
          {addressPart2}
        </Text>
      </Box>
      <Flex mt={6} flexDirection="column" gap={3}>
        <Link
          href={`https://www.google.com/maps/dir/?api=1&destination=${name} ${addressPart1} ${addressPart2}`}
          target="_blank"
        >
          <Flex alignItems="center" gap={2}>
            <Icon as={MdOutlineDirections} />
            <Text fontWeight="thin" textDecor="underline" color="gray.600">
              {t(`templates.layout.stores.Store.GetDirections`)}
            </Text>
          </Flex>
        </Link>
        {hasPhoneNumber && (
          <Link href={`tel:${phone}`}>
            <Flex alignItems="center" gap={2}>
              <Icon as={RiPhoneLine} />
              <Text fontWeight="thin" textDecor="underline" color="gray.600">
                {phone}
              </Text>
            </Flex>
          </Link>
        )}
        {hasEmailAddress && (
          <Link href={`mailto:${emailAddress}`}>
            <Flex alignItems="center" gap={2}>
              <Icon as={MdOutlineMailOutline} />
              <Text fontWeight="thin" textDecor="underline" color="gray.600">
                {emailAddress}
              </Text>
            </Flex>
          </Link>
        )}
      </Flex>
    </Box>
  )
}

export default StoreAddress
